module.exports = __webpack_public_path__ + "img/category-skill-game.3aef84db.png";